import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ChatProviderInstance } from '@sxm-core/utility-code/angular/configuration-token-chat-provider-instance';

/**
 * @deprecated Use ChatProviderSierra from de-care/libs/inventory/utility-code/angular/app-providers-chat/src/lib/chats/sierra/ChatProviderSierra.ts
 */
export class ChatProviderSierra implements ChatProviderInstance {
    private readonly document = inject(DOCUMENT);
    name: 'sierra';

    constructor() {
        const styleElement = this.document.createElement('style');
        styleElement.textContent = `div[data-sierra-chat-launcher] { position: absolute; }`;
        this.document.head.appendChild(styleElement);
    }

    openChat() {
        this.document?.defaultView['sierraSXM']['openChatModal']();
    }
}

export class ChatProviderLivePerson implements ChatProviderInstance {
    name: 'liveperson';

    openChat() {
        // Not currently used for this provider
    }
}

export class ChatProvider247 implements ChatProviderInstance {
    name: '247';

    openChat() {
        // Not currently used for this provider
    }
}
